
export default async function filterContacts(query, contacts) {
    const clone = { ...contacts };
    var keywords = query.split(' ');
    await Object.keys(contacts).forEach((key) => {
        const newGroup = [];

        contacts[key].forEach((item) => {

            const Nickname = item.Nickname && [].concat.apply([], Object.values(item.Nickname?.infoValue).map(name => name.split(' ')));
            const NamePrefix = item.NamePrefix && [].concat.apply([], Object.values(item.NamePrefix?.infoValue).map(name => name.split(' ')));
            const FirstName = item.FirstName && [].concat.apply([], Object.values(item.FirstName?.infoValue).map(name => name.split(' ')));
            const MiddleName = item.MiddleName && [].concat.apply([], Object.values(item.MiddleName?.infoValue).map(name => name.split(' ')));
            const LastName = item.LastName && [].concat.apply([], Object.values(item.LastName?.infoValue).map(name => name.split(' ')));
            const NameSuffix = item.NameSuffix && [].concat.apply([], Object.values(item.NameSuffix?.infoValue).map(name => name.split(' ')));
            const JobTitle = item.JobTitle && [].concat.apply([], Object.values(item.JobTitle?.infoValue).map(name => name.split(' ')));
            const Company = item.Company && [].concat.apply([], Object.values(item.Company?.infoValue).map(name => name.split(' ')));
            const Department = item.Department && [].concat.apply([], Object.values(item.Department?.infoValue).map(name => name.split(' ')));

            if (NamePrefix && NamePrefix.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (FirstName && FirstName?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (MiddleName && MiddleName?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (LastName && LastName?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (Nickname && Nickname?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (NameSuffix && NameSuffix?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (JobTitle && JobTitle?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (Company && Company?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (Department && Department?.find(k => keywords.find(word => k.toLowerCase().startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            } else if (item?.labelName && keywords.find(word => item?.labelName?.toLowerCase().split(' ').find(k => k.startsWith(word.toLowerCase())))) {
                newGroup.push(item)
            }

        })
        if(newGroup.length)
            clone[key] = newGroup;
        else
            delete clone[key]
    })
    return clone;
}